import { HttpError } from '@refinedev/core';

export const handleErrorMessages = (error: HttpError) => {
  if (
    'errors' in error.response.data &&
    error.response.data.errors.length > 0
  ) {
    return error.response.data.errors[0].message;
  }

  return error.response.data.message;
};
